module.exports = __webpack_public_path__ + "static/img/count.3b1cc0ff.png";